import React from 'react';

const Googlekeppin = (props) => {
  const deleteNote = () => {
    return (
      props.deleteItem(props.id)
    )
  }

return(

<><div className='col-md-3 mb-3'>
  <div className=' card p-5 bg-light'>
    <h3>{props.title}</h3>
    <p>{props.content}</p>
    <button onClick={deleteNote} className='btn btn-danger'>Delete</button>
  </div>
</div>
</>);
};

export default Googlekeppin;
